<template>
  <PageHeader
    :title="'Intelligence Studio'"
    :subtitle="'Configure LLM-driven analyses — Sources, Tasks, Analyses'"
    :breadcrumbs="[{ label: 'Beta' }]"
  >
    <template #bottom>
      <Page_Tabs
        class="px-6 pt-4"
        :tabs="tabLabels"
        :initial-tab="selectedTabLabel"
        no-border
        @select="handleTabSelect"
      />
    </template>
  </PageHeader>

  <div class="p-4">
    <div class="bg-white rounded-lg border border-gray-200">
      <AnalysisEditor v-if="selectedTab === 'analyses'" />
      <SourceConfigsView v-else-if="selectedTab === 'source_configs'" />
      <TasksView v-else-if="selectedTab === 'tasks'" />
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue'
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue'
import AnalysisEditor from './AnalysisEditor.vue'
import SourceConfigsView from './SourceConfigsView.vue'
import TasksView from './TasksView.vue'

const TABS = [
  { id: 'analyses',       name: 'Analyses' },
  { id: 'source_configs', name: 'Sources' },
  { id: 'tasks',          name: 'Tasks' },
]
const VALID_IDS = new Set(TABS.map(t => t.id))

export default {
  name: 'IntelligenceStudio',

  components: {
    PageHeader,
    Page_Tabs,
    AnalysisEditor,
    SourceConfigsView,
    TasksView,
  },

  data() {
    const stored = localStorage.getItem('intelligence_studio_tab')
    return {
      selectedTab: VALID_IDS.has(stored) ? stored : 'analyses',
      tabs: TABS,
    }
  },

  computed: {
    tabLabels() {
      return this.tabs.map(t => t.name)
    },
    selectedTabLabel() {
      const tab = this.tabs.find(t => t.id === this.selectedTab)
      return tab ? tab.name : this.tabs[0].name
    },
  },

  methods: {
    handleTabSelect(label) {
      const tab = this.tabs.find(t => t.name === label)
      if (tab) this.selectedTab = tab.id
    },
  },

  watch: {
    selectedTab(newTab) {
      localStorage.setItem('intelligence_studio_tab', newTab)
    },
  },
}
</script>
